export const ETSY_MATCHING_TAB_QUERY_KEY = 'matchingTab';
export const ETSY_SELECTED_ORDER_QUERY_KEY = 'etsyOrderId';

export const MATCHING_TABS = {
  variations: 'variations',
  papers: 'papers',
  sizes: 'sizes',
  addresses: 'addresses',
  images: 'images',
} as const;

export type MatchingTab = (typeof MATCHING_TABS)[keyof typeof MATCHING_TABS];

export const getMatchingTab = (value: string | null): MatchingTab => {
  if (
    value === MATCHING_TABS.variations
    || value === MATCHING_TABS.papers
    || value === MATCHING_TABS.sizes
    || value === MATCHING_TABS.addresses
    || value === MATCHING_TABS.images
  ) {
    return value;
  }

  return MATCHING_TABS.variations;
};
